import axios from "axios";
import apiUrlOne from "../Config";

export const createCoupon = async (formData) => {
    const response = await axios.post(
        `${apiUrlOne}/coupons/create`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response.data;
};

export const updateCoupon = async (id, formData) => {
    const response = await axios.put(
        `${apiUrlOne}/coupons/update/${id}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response.data;
};


export const deleteCoupon = async (id) => {
    const response = await axios.delete(`${apiUrlOne}/coupons/delete/${id}`);
    return response.data;
};

export const getAllCoupons = async () => {
    const response = await axios.get(`${apiUrlOne}/coupons/getall`);
    return response.data;
};
